import { Role } from 'auth';
import { Navigate, useSearchParams } from 'react-router-dom';
import { withPrivateAccess } from '@/modules/auth/hocs/withPrivateAccess.tsx';
import { useIssuerPortfoliosInfiniteListQuery } from '@/modules/issuer-dashboard/queries/portfolios.tsx';
import { issuerDashboardPaths } from '@/modules/issuer-dashboard/routes.tsx';
import { PageLayout, Spinner } from 'ui';

const IssuerPortfolios = () => {
  const [params] = useSearchParams();
  const { data, isError } = useIssuerPortfoliosInfiniteListQuery({
    page: 1,
    page_size: 1,
  });
  const portfolio = data?.pages[0]?.data?.[0];

  if (portfolio) {
    return (
      <Navigate
        replace
        to={{
          pathname: issuerDashboardPaths.dynamic.portfolio(portfolio.id.toString()),
          search: params.toString(),
        }}
      />
    );
  }

  return (
    <PageLayout title="Custody" contentClassName="px-0 py-2">
      <div className="flex h-[250px] items-center justify-center">
        {isError ? 'Portfolio is unavailable' : <Spinner size="lg" />}
      </div>
    </PageLayout>
  );
};

export default withPrivateAccess(IssuerPortfolios, [Role.SR_ISSUER, Role.SR_ISSUER_ADMIN]);
